/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Link, Panel, Hr, Margin, Table, Text } from 'shared/components'
import { admin } from 'routes/route.map'

import { BeneficiaryFilters } from './components/filters'
import * as styles from './styles'

const BeneficiariesOverviewComponent = ({
  columns,
  onSearch,
  loadBeneficiaries,
}) => (
  <Panel>
    <div css={styles.pageHeader}>
      <Text as="h1" size={18} bold>
        Beneficiaries
      </Text>
      <Margin tb={3}>
        <Hr width="full" />
      </Margin>
      <div css={styles.pageToolbar} data-testid="page-toolbar">
        <div css={styles.filtersSlot}>
          <Margin bottom={2}>
            <BeneficiaryFilters debounce={250} onSearch={onSearch} />
          </Margin>
        </div>
        <div css={styles.actionsSlot} data-testid="page-toolbar-action">
          <div css={styles.controlsWrapper}>
            <Link to={admin.beneficiaries.add()}>
              <Button plain>
                <FontAwesomeIcon size="1x" icon="plus-circle" />
                <Text size={11}>Add beneficiary</Text>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
    <div css={styles.tableSection}>
      <Table
        id="beneficiaries-table"
        sortable
        columns={columns}
        loadData={loadBeneficiaries}
      />
    </div>
  </Panel>
)

BeneficiariesOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadBeneficiaries: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
}

export default BeneficiariesOverviewComponent
